/**
 * Help topic registry.
 * Maps topic slugs to metadata (i18n title key, description key,
 * and lazy-loadable content components keyed by locale).
 *
 * @module pages/help/helpTopicRegistry
 */

import * as constants from '../../constants';

const helpTopicRegistry = [
  {
    slug:           constants.HELP_TOPIC_AGENT_LIFECYCLE,
    titleKey:       'help.topic.agentLifecycle.title',
    descriptionKey: 'help.topic.agentLifecycle.description',
    load: {
      en: () => import('./content/en/AgentLifecycleVerification'),
    },
  },
  {
    slug:           constants.HELP_TOPIC_DISABLE_PLUGIN,
    titleKey:       'help.topic.disablePlugin.title',
    descriptionKey: 'help.topic.disablePlugin.description',
    load: {
      en: () => import('./content/en/DisablePlugin'),
    },
  },
  {
    slug:           constants.HELP_TOPIC_VIEW_PLUGIN_LOGS,
    titleKey:       'help.topic.viewPluginLogs.title',
    descriptionKey: 'help.topic.viewPluginLogs.description',
    load: {
      en: () => import('./content/en/ViewPluginLogs'),
    },
  },
  {
    slug:           constants.HELP_TOPIC_VIEW_WORKSPACES,
    titleKey:       'help.topic.viewWorkspaces.title',
    descriptionKey: 'help.topic.viewWorkspaces.description',
    load: {
      en: () => import('./content/en/ViewWorkspacesAndAgents'),
    },
  },
];

export default helpTopicRegistry;
